import * as React from 'react';
import { noop } from 'lodash';

import { ToggleField } from '@components/form';

export const ToggleTwoLabels: React.SFC<any> = ({
  component,
  style,
  styleLabelLeft,
  styleLabelRight,
  name,
  onToggle,
  labelLeft,
  labelRight,
  onClickLeft,
  onClickRight,
  disabled,
  ...rest
}) => {
  const toggleName: string = name as string;
  return (
    <div style={style || { display: 'flex', justifyContent: 'flex-start' }}>
      <span
        style={styleLabelLeft || { marginRight: 15, cursor: disabled ? 'auto' : 'pointer' }}
        onClick={disabled ? noop : onClickLeft}
      >
        {labelLeft}
      </span>
      <div style={{}}>
        <ToggleField
          component={component}
          name={toggleName}
          label=""
          onToggle={onToggle}
          disabled={disabled}
          {...rest}
        />
      </div>
      <span
        style={styleLabelRight || { marginLeft: 15, cursor: disabled ? 'auto' : 'pointer' }}
        onClick={disabled ? noop : onClickLeft}
      >
        {labelRight}
      </span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/form/ToggleTwoLabels/ToggleTwoLabels.tsx